exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editor[data-v-c8dda670] {\n    min-height: 300px;\n}\n", ""]);

// exports
